import React, { useState } from 'react';
import Modal from 'react-modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUser, faBuilding } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';
import LoadingScreen from '../../../LoadingScreen';

import SimpleModal from './SimpleModal';

const customModalStyles = {
  content: {
    width: '80%', 
    height: '85%',
    maxWidth: '600px',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    //justifyContent: 'center', // Center vertically
    alignItems: 'center', // Center horizontally
    borderRadius: '1%',
  },
};

const AddUsersModal = ({ isOpen, onRequestClose, onAddUser, institutions }) => {
  const [institution, setInstitution] = useState('');
  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [type, setType] = useState('');

  //const [selectedFile, setSelectedFile] = useState({});

  const [isNetworkLoading, setIsNetworkLoading] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState(null);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSimpleModalOpen, setIsSimpleModalOpen] = useState(false);
  const [registrationError, setRegistrationErrorMessage] = useState('');


      // Function to close the modal
      const closeSimpleModal = () => {
        setIsSimpleModalOpen(false);
        clearFields();
        if (registrationStatus == "Registration Successful") {
          //navigate("/");
          ////onRequestClose();

          
        clearFields();

        // Close the modal
        onAddUser();
        }
        
      };


  const clearFields = () => {
    //
    setInstitution('');
    setFullname('');
    setEmail('');
    setType('');
    
    setRegistrationStatus(null);
    setIsSimpleModalOpen(false);
    setRegistrationErrorMessage('');
          //
  }
  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setInstitution(selectedValue);
  };

  const handleDropdownTypeChange = (event) => {
    const selectedValue = event.target.value;
    setType(selectedValue);
  //
  //alert(selectedValue);
  };

      // Function to validate email format
      const isValidEmail = (email) => {
        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };

  const hitAddUserEndpoint = async () => {
    
     // Validate email before proceeding
     if (!isValidEmail(email)) {
      alert('Invalid email address');
      //setRegistrationStatus("Invalid email address");
      //setIsModalOpen(true);
      return;
    }

    //onAddInstitution(institutionName);
    //setInstitutionName('');

    setRegistrationErrorMessage('');
    setIsNetworkLoading(true);
    

    // alert(
    //   'institution: ' + institution +
    //     '\nfullname: ' + fullname +
    //     '\nemail: ' + email +
    //     '\ntype: ' + type 
    // );


    if (
      institution  == ''  ||
      fullname == '' ||
      email == '' ||
      type == ''
      ) {

        const faultyFields = [];
        if (institution == '') faultyFields.push("Institution");
        if (fullname == '') faultyFields.push("Fullname");
        if (email == '') faultyFields.push("Email");
        if (type == '') faultyFields.push("Select Type");
        const errorMessage = `Please fill out all required fields: ${faultyFields.join(', ')}`;
        setRegistrationErrorMessage(errorMessage);

      //alert("Please select a type.");
      setIsNetworkLoading(false);
      return;
    }


    try {
      const token = localStorage.getItem('token')
      //alert(token);

      const formData = new FormData();
      formData.append('institution', institution);
      formData.append('fullname', fullname);
      formData.append('email', email);
      formData.append('type', type);
      

      const response = await axios.post("https://gacsstage.zaptrance.ng/api/admin/users", formData, {
        headers: {
          //'Content-Type': 'multipart/form-data', // Use multipart/form-data for file uploads
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setIsNetworkLoading(false);

      if (response.data.success) {
        // Registration was successful, you can handle the response here
        //alert("ok " + response.data.message);
        setRegistrationStatus("Registration Successful");
        setIsSimpleModalOpen(true);
        //console.log('Registration successful:' + response.data.message);


        // clearFields();

        // // Close the modal
        // onAddUser();

        // You can also redirect the user to a confirmation page or do any other actions.
      } else {
        // Handle the case where registration was not successful
        //alert("not ok");
        setRegistrationStatus("Registration Failed");
        setIsSimpleModalOpen(true);
        //console.error('Registration failed:' + response.data);
        setRegistrationErrorMessage(response.data);
      }
    } catch (error) {
      setIsNetworkLoading(false);

      setRegistrationStatus("Registration Failed");
      //console.error('Registration Failed:'+ error.message);

  if (error.response && error.response.data && error.response.data.data) {
    const dataKeys = Object.keys(error.response.data.data);

    try {
      if (dataKeys.length > 0) {
        // Construct an error message from the data keys
        const errorMessage = dataKeys
          .map(key => {
            const messages = error.response.data.data[key];
            //return `${key}: ${messages.join(', ')}`;
            return `${messages.join(', ')}`;
          })
          .join('\n');
  
        setRegistrationErrorMessage(errorMessage);
      } else {
        // If there are no data keys, set a generic error message
        setRegistrationErrorMessage('An error occurred during registration.');
      }
    } catch {
      //alert(error.response.data.data);
      setRegistrationStatus("Registration Failed");
        setIsSimpleModalOpen(true);
      setRegistrationErrorMessage(error.response.data.data);
    }

  } else {
    // Handle other error cases if needed
    setRegistrationErrorMessage('An error occurred during registration.');
  }

    }
  };

  // const handlePaymentEvidenceChange = (e) => {
  //   const selectedFile = e.target.files[0];
  //   setSelectedFile(selectedFile);
  // };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Add Institution Modal"
      style={customModalStyles}
    >
      <div className="flex justify-between items-center w-full px-2 pt-42">
  <div className="flex items-center">
    <FontAwesomeIcon icon={faUser} color="black" className='mr-6' size="2x"/>
    <h2 className='text-xl'>Add User</h2>

    


  </div>





  <div>
    <button
      onClick={onRequestClose}
      className="border p-2"
      style={{
        background: 'none',
        cursor: 'pointer',
        borderRadius: '50%',
        borderColor: 'black',
        display: 'inline-block',
        width: '30px',
        height: '30px',
        padding: '0',
      }}
    >
      <span aria-hidden="true">
        <FontAwesomeIcon icon={faTimes} color="black" />
      </span>
    </button>
  </div>
</div>


      <div className="w-full px-2 pt-4">

      <div className="w-full px-2 pt-4">

      <div className="flex flex-col py-2">
          <label>Type</label>
          <select 
          className="mt-2 p-2 focus rounded-lg"
          // className="mt-2 p-2 focus border-blue-500 border-2 rounded-xl"
          onChange={(e) => handleDropdownTypeChange(e)}
        >
          <option value="0">Select Type</option>
          <option value="1">Zaptrance</option>
          <option value="2">Nbte</option>
          <option value="3">Rector</option>
          <option value="4">Registrar</option>
          <option value="5">Institution Admin</option>
        </select>
        </div>


      <div className="flex flex-col py-2">
          <label>Institution</label>
         
          {<select
          className="mt-2 p-2 focus rounded-lg"
          onChange={(e) => handleDropdownChange(e)}
        >
          <option value="Select">Select</option>
          {type === "0" || type === "1" || type === "2" ? null : institutions.map((institution, index) => (
            <option key={index} value={institution.id}>
              {institution.name}
              </option>
          ))}
        </select>}
          
        </div>

        <div className="flex flex-col py-2">
          <label>Fullname</label>
          <input
            style={{ backgroundColor: '#EDF2F6', width: '100%' }}
            className="rounded-lg mt-2 p-2 focus"
            type="text"
            placeholder="Enter Fullname"
            value={fullname}
            onChange={(e) => setFullname(e.target.value)}
          />
        </div>

        <div className="flex flex-col py-2">
          <label>Email</label>
          <input
            style={{ backgroundColor: '#EDF2F6', width: '100%' }}
            className="rounded-lg mt-2 p-2 focus"
            type="text"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        
        </div>


        <div className='text-center' style={{ display: 'flex', justifyContent: 'center' }}>
        <p className='text-center mb-4 text-red-500'
        style={{ 
          //color: 'red',//'#990000', 
          fontSize: '12px' }}>{registrationError}</p>
      </div>


        <div className="text-center">
            <button className="px-6 py-3 m-4" 
            style={{
            width: '200px',
            backgroundColor: '#095918',
            borderRadius: '30px',
            padding: '10px 20px',
            color: 'white',
            border: 'none',
          }}
            onClick={hitAddUserEndpoint}
            >
              {isNetworkLoading ? (
                      <LoadingScreen />
                    ) : (
                      'Submit'
                    )}
              </button>
            </div>


      </div>
      <SimpleModal 
isOpen={isSimpleModalOpen}
onRequestClose={closeSimpleModal}
registrationStatus={registrationStatus}
              registrationError={registrationError}
              message='User'
/>


    </Modal>
  );
};

export default AddUsersModal;
